<template>
    <div>
        <!-- 轮播图 -->
        <van-swipe :lazy-render="true" class="banner" :autoplay="3000" indicator-color="white">
            <van-swipe-item><img src="../../../public/img/homepage/1.jpg"></van-swipe-item>
            <van-swipe-item><img src="../../../public/img/homepage/2.jpg"></van-swipe-item>
            <van-swipe-item><img src="../../../public/img/homepage/3.jpg"></van-swipe-item>
            <van-swipe-item><img src="../../../public/img/homepage/4.jpg"></van-swipe-item>
            <van-swipe-item><img src="../../../public/img/homepage/5.jpg"></van-swipe-item>
        </van-swipe>

        <!-- WO WE ARE -->
        <h6 class="title_g">WHO WE ARE</h6>
        <div class="who global_p">
            <p>Globalway, belongs to Ningbo Hooya group (since 1998), a general merchandise supplier since 2010, offering over 50,000 items, including houseware, kitchenware, personal care & beauty, gifts & seasonal items, toys, stationery, home textile, slippers, bag & luggage, travel & outdoor & BBQ items, garden tools, hand tools, car accessories, home appliance, furniture, baby and pet items.</p>
            <p>Main markets are Europe, USA, South America and Asia.</p>
            <p>Main clients are chain store, importer, wholesaler and Amazon seller.</p>
            <p>With 5 buying office in China, we buy from factories direct, every item will be produced newly under order.</p>
            <p>Can do client's special design, artwork, logo printing.</p>
        </div>

        <!-- WHAT WE DO -->
        <h6 class="title_g">WHAT WE DO</h6>
        <div class="what-we-do">
            <img src="../../../public/img/homepage/whatwedo.png" alt="">
        </div>

        <h6 class="title_g">PRODUCTS<br><p>What categories we have</p></h6>
        <div class="products">
            <div v-for="(item, index) in catalogList" :key="index" @click="jumpToProducts(item.Id)">
                <img :src="item.Url" class="bg">
                <div>
                    <van-image
                        :src="item.Icon"
                        lazy-load
                        class="icon"
                        fit="contain"
                    /><br/>
                    <span>{{item.CategoryName}}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    Swipe as VanSwipe,
    SwipeItem as VanSwipeItem,
    Image as VanImage,
} from 'vant';
import axios from 'axios';

export default {
    name: 'Layout',
    data() {
        return {
            catalogList: []
        }
    },
    mounted() {
        this.generateCatalog();
    },
    methods: {
        jumpToProducts(id) {
            const catalog = this.$store.state.catalog.filter(i => i.id === id)[0];
            const childId = catalog.children[0].id;

            this.$router.push(`/products?id=${childId}`);
            this.$store.commit('setCatalogName', `${catalog.title}|${catalog.children[0].title}`)
        },
        async generateCatalog() {
            const reqData = {
                "page": 1,
                "rows": 100,
                "sort": "CreateDate",
                "order": "desc",
                "wheres": "[]"
            }
            const response = await axios.post('/api/Alibaba_Category/GetPageDataHome', reqData)

            let list = [];
            response.data.rows.forEach(i => {
                list.push({
                    Url: i.Url,
                    Icon: i.Icon,
                    CategoryName: i.CategoryName,
                    Id: i.Category_Id
                })
            })
            this.catalogList = list
        }
    },
    components: { VanSwipe, VanSwipeItem, VanImage }
}
</script>

<style lang="less" scoped>
    .banner img { width: 100%; }
    .who { padding: 0 1rem; }
    
    .what-we-do { background-color: #d8d4d3; }
    .what-we-do img { width: 100%; padding: 1rem 0; }
    
    .products { width: calc(100% - 4px); padding: 0 2px; display: inline-block; font-size: 0; }
    .products > div { width: calc(50% - 8px); padding-bottom: calc(50% - 8px); margin: 4px; display: inline-block; position: relative; background: #CCC; }
    .products > div .bg { width: 100%; height: 100%; position: absolute; left: 50%; top: 50%; object-fit: contain; transform: translate(-50%, -50%); }
    .products > div > div { position: absolute; background-color: rgba(255, 255, 255, .8); font-size: .8rem; text-align: center; width: 60%; height: 40%; top: 48%; left: 50%; transform: translate(-50%, -50%); }
    .products > div > div .icon { width: 1.6rem; height: 1.6rem; margin-top: 1rem; }
</style>